/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne Swagger
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 4bcfc99b (Thu Mar  7 14:01:07 UTC 2024)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  ProgramEnrollment,
  ProgramEnrollmentFromJSON,
  ProgramEnrollmentToJSON,
} from './'

/**
 *
 * @export
 * @interface CompleteEnrollmentInviteResponse
 */
export interface CompleteEnrollmentInviteResponse {
  /**
   * All enrollments created during the completion of the enrollment invitation. Each enrollment will be either in the PENDING or ENROLLED status.
   * @type {Array<ProgramEnrollment>}
   * @memberof CompleteEnrollmentInviteResponse
   */
  createdEnrollments: Array<ProgramEnrollment>
}

export function CompleteEnrollmentInviteResponseFromJSON(
  json: any
): CompleteEnrollmentInviteResponse {
  return CompleteEnrollmentInviteResponseFromJSONTyped(json, false)
}

export function CompleteEnrollmentInviteResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CompleteEnrollmentInviteResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    createdEnrollments: (json['createdEnrollments'] as Array<any>).map(
      ProgramEnrollmentFromJSON
    ),
  }
}

export function CompleteEnrollmentInviteResponseToJSON(
  value?: CompleteEnrollmentInviteResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    createdEnrollments: (value.createdEnrollments as Array<any>).map(
      ProgramEnrollmentToJSON
    ),
  }
}
